import styled from 'styled-components'

const StyledFooterSocialMedia = styled.div`
  margin-left: -16px;
`
const StyledLink = styled.a`
  padding: 0 16px;
`
export { StyledFooterSocialMedia, StyledLink }
